// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTIVATE_ENTRY = "Aktivuj";
export const BAZAAR_NOTES_ADD_NOTE = "P\u0159idej pozn\u00e1mku k u\u017eivatelce...";
export const BAZAAR_NOTES_TO_NOTES = "Do pozn\u00e1mek\u2026";
export const BZ2_PRODUCT_DELETE_CONFIRM = "Opravdu chce\u0161 smazat tento inzer\u00e1t?";
export const CHANGE_ENTRY = "Zm\u011b\u0148";
export const DELETE_ENTRY = "Vyma\u017e";
export const INACTIVATE_ENTRY = "Pozastav";
export const REPOST_ENTRY = "Aktualizuj";
export const SELLER_ACTION_BUTTONS_UNDELETE = "Obnovit";
export const SELLER_ACTION_BUTTONS_UNDELETE_CONFIRM = "Opravdu chce\u0161 obnovit tento inzer\u00e1t?";
export const YOU_HAVE_NO_MORE_REPOSTS_SHORT = "YOU_HAVE_NO_MORE_REPOSTS_SHORT";
